/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

import { customMedia } from 'styles/utils';

interface InfoSectionProps {
  left?: number;
}

interface InfoItemProps {
  lineThrough?: boolean;
  collapsed?: boolean;
  dark?: boolean;
  eq?: boolean;
  add?: boolean;
  del?: boolean;
  edit?: boolean;
  transf?: boolean;
  background?: string;
}

interface HoverItemProps {
  diffLabel?: string;
}

export const InfoSectionStyled = styled.aside<InfoSectionProps>`
  display: flex;
  z-index: 10001;
  position: fixed;
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.wfGrey700};
  bottom: 0;
  left: ${props => props.left}px;

  ${customMedia.lessThan('medium')`
    display: none;
  `}
`;

export const InfoItem = styled.li<InfoItemProps>`
  flex-shrink: 0;
  padding: ${props => (props.collapsed ? '2px 8px' : '2px 4px')};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: ${props =>
    props.dark ? props.theme.color.wfGrey : props.theme.color.wfGrey900};
  background: ${props => props.background && props.background};
  border-right: 1px solid
    ${props => (props.collapsed ? 'transparent' : props.theme.color.wfGrey400)};
  &:first-child {
    cursor: pointer;
  }
  &:last-child {
    border-right: none;
  }
  text-decoration: ${props => props.lineThrough && 'line-through'};
`;

export const DebugInfoItem = styled.li<InfoItemProps>`
  flex-shrink: 0;
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: ${props => props.theme.color.wfGrey700};
  color: ${props => props.theme.color.wfWhite};
  border-right: 1px solid ${props => props.theme.color.wfGrey400};
  &:first-child {
    cursor: pointer;
  }
  &:last-child {
    border-right: none;
  }
  text-decoration: ${props => props.lineThrough && 'line-through'};
`;

export const SupScript = styled.span`
  top: -4px;
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
`;

interface NavigationListProps {
  visible?: boolean;
}

export const NavigationList = styled.ul<NavigationListProps>`
  user-select: none;
  display: flex;
  padding: 0;
  height: 100%;
  background: ${props => props.theme.color.wfGrey50};
  border-right: 1px solid ${props => props.theme.color.wfGrey400};
  border-top: 1px solid ${props => props.theme.color.wfGrey400};
  border-top-right-radius: 8px;
  width: ${props => (props.visible ? 'auto' : '32px')};

  overflow-x: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
  }
  transition: width 256ms ease-in-out;
`;

export const HoverList = styled.ul<NavigationListProps>`
  user-select: none;
  display: flex;
  padding: 0 0 0 0.5rem;
  color: ${props => props.theme.color.wfBlack};
`;

export const HoverItem = styled.li<HoverItemProps>`
  flex-shrink: 0;
  height: 100%;
  padding: 0 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.95rem;
  text-shadow: -1px -1px 0 #ffffffaa, 1px 1px 0 #ffffffaa, -1px 1px 0 #ffffffaa,
    1px -1px 0 #ffffffaa, 1px 0 0 #ffffffaa, -1px 0 0 #ffffffaa,
    0 1px 0 #ffffffaa, 0 -1px 0 #ffffffaa;
`;
